import { apiClient } from './apiClient';

export type APITokenRecord = {
  id: string;
  name: string;
  scopes: string[];
  createdAt: string;
  lastUsedAt?: string;
  expiresAt?: string;
  revokedAt?: string;
};

export const MUSIC_SCOPES = ['music:read', 'music:write'] as const;
export const CREATOR_SCOPES = ['creator:read', 'creator:write'] as const;

export async function listApiTokens(): Promise<APITokenRecord[]> {
  const response = await apiClient.get<{ success: boolean; tokens: APITokenRecord[] }>('/users/me/api-tokens');
  return response.data.tokens ?? [];
}

export async function createApiToken(name: string, scopes: string[]): Promise<{ token: APITokenRecord; secret: string }> {
  const response = await apiClient.post<{ success: boolean; token: APITokenRecord; secret: string }>(
    '/users/me/api-tokens',
    { name, scopes },
  );
  return { token: response.data.token, secret: response.data.secret };
}

export async function revokeApiToken(id: string): Promise<void> {
  await apiClient.delete(`/users/me/api-tokens/${encodeURIComponent(id)}`);
}

export function buildMcpConfigSnippet(apiUrl: string, secret: string, product: 'music' | 'creator' | 'both' = 'both'): string {
  return JSON.stringify(
    {
      mcpServers: {
        cassette: {
          command: 'npx',
          args: ['-y', '@cassette.diy/mcp'],
          env: {
            CASSETTE_API_URL: apiUrl,
            CASSETTE_API_TOKEN: secret,
            CASSETTE_PRODUCT: product,
          },
        },
      },
    },
    null,
    2,
  );
}
